import { LOCAL_STORAGE_WORKSPACE_ID } from 'config/constants';
import React from 'react';
import './style.scss';
import taglogo from 'assets/images/tagLogo.png';
import priologo from 'assets/images/prioLogo.png';
import jiraulogo from 'assets/images/jirauLogoBranco.png';
import equinorLogo from 'assets/images/equinorLogo.jpg';
import { useFeatureFlag } from '@shape/feature-flag';
export const TAG_WORKSPACE_ID = 'e79995c6-d8a8-4a3d-ae85-62e3be62fdab';
export const PRIO_WORKSPACE_ID = '0462133f-1a02-46b0-a0e2-ca7f7dc5db56';
export const JIRAU_WORKSPACE_ID = '2dbb0d62-78b7-452a-bfb0-78de5bde27c7';

const ClientLogo: React.FC<{ alt?: string }> = ({ alt }) => {
  const workspaceId = localStorage.getItem(LOCAL_STORAGE_WORKSPACE_ID) as string;
  const isDemoOTCEnabled = useFeatureFlag('demo-OTC');
  const isEquinor = useFeatureFlag('is-equinor');

  if (isEquinor) {
    return (
      <div className="client-logo summary-box_img-wrapper equinor">
        <img src={equinorLogo} alt={alt ?? 'Equinor'} className="summary-box_img" />
      </div>
    );
  }
  const defaultImagepath = isDemoOTCEnabled
    ? '/images/Shape_Logo_Dark-mode.svg'
    : '/images/modec.png';
  const defaultAlt = isDemoOTCEnabled ? 'Shape' : 'Modec';
  switch (workspaceId) {
    case TAG_WORKSPACE_ID:
      return (
        <div className="client-logo summary-box_img-wrapper">
          <img src={taglogo} alt={alt ?? 'Tag'} className="summary-box_img" />
        </div>
      );
    case PRIO_WORKSPACE_ID:
      return (
        <div className="client-logo summary-box_img-wrapper">
          <img src={priologo} alt={alt ?? 'Prio'} className="summary-box_img-ligth" />
        </div>
      );

    case JIRAU_WORKSPACE_ID:
      return (
        <div className="client-logo summary-box_img-wrapper jirau">
          <img src={jiraulogo} alt={alt ?? 'Jirau'} className="summary-box_img" />
        </div>
      );
    default:
      return (
        <div className="client-logo summary-box_img-wrapper">
          <img src={defaultImagepath} alt={alt ?? defaultAlt} className="summary-box_img-ligth" />
        </div>
      );
  }
};

export default ClientLogo;
